import React from 'react';
import { Row, Col, Button } from 'antd';
import {getBackgroundImage} from '../../infrastructure/helpers/getBackgroundImage'

function BackgroundBlock({ subHeadline, headline, displayReadMore, marginTop }) {
  return (
    <Row style={{ marginTop, backgroundSize: 'cover' }}>
      <video style={{ marginBottom: -10, position: 'absolute', width: '100%', marginLeft: '-50%' }} autoPlay loop muted>
        <source src={getBackgroundImage('bottom')} type='video/mp4' />
      </video>
      <Col md={{ span: 16, offset: 4 }}>
        <Row className="bottom_block_row">
          <Col md={{ span: 24 }}>
            <div className="bottom_block_subheadline">{subHeadline}</div>
            <h2 className="bottom_block_headline">
              {headline}
            </h2>
            {displayReadMore && <Button className="bottom_block_button">View more details</Button>}
          </Col>
          <Col md={{ span: 12 }} />
        </Row>
      </Col>
    </Row>
  );
}

export default BackgroundBlock;

BackgroundBlock.defaultProps = {
  headline: 'It\'s all about leadership',
  subHeadline: 'It\'s all about leadership',
  displayReadMore: false,
  marginTop: '0px'
}


// WEBPACK FOOTER //
// ./src/components/BackgroundBlock/index.js